import { graphql, useStaticQuery } from "gatsby";
import { useLanguage } from "../../utils/localization/languages/I18nContext";
import { StaticShipsDataQuery } from "types/graphql-types";
import {
  LocalizedStaticQueryResult,
  localizeStaticQuery
} from "./localizeStaticQuery";

export type useStaticShipDataReturn = LocalizedStaticQueryResult<
  StaticShipsDataQuery["ships"]["nodes"][0]
>[];

export interface useStaticShipDataArgs {
  showExpeditionsOnly?: boolean;
}

const useStaticShipsData = ({
  showExpeditionsOnly = false
}: useStaticShipDataArgs): useStaticShipDataReturn => {
  const language = useLanguage();
  const { ships } = useStaticQuery<StaticShipsDataQuery>(
    graphql`
      query StaticShipsData {
        ships: allSanityShip(sort: { order: ASC, fields: card___title___en }) {
          nodes {
            _id
            id
            shipType
            fullPath
            i18nFullPaths
            metadata {
              tracking {
                name
              }
            }
            card {
              ...AsCardForStaticQuery
            }
          }
        }
      }
    `
  );

  let nodes = ships.nodes;
  if (showExpeditionsOnly)
    nodes = nodes.filter((n) => n.shipType == "Expedition");

  return localizeStaticQuery(nodes, language);
};

export default useStaticShipsData;
